import { NotificationSettings } from "../models/UserCustomers";

export interface CustomerRelation {
	id: string;
	notificationSetting?: NotificationSettings;
}

/**
 * Reduce customer relations to the fields `PUT /customer-account/:id` accepts.
 *
 * Customer users returned by the list/search endpoints carry expanded,
 * read-only fields on each linked customer (e.g. `name`), and the update
 * request schema rejects any additional property. Always run relations
 * through this before sending them back.
 */
export const toRelationPayload = (rows: CustomerRelation[]): CustomerRelation[] =>
	rows.map(({ id, notificationSetting }) => ({ id, notificationSetting }));
